import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import CardWrapper from "cards/components/CardWrapper";
import styles from "./IssuesModule.css";

export default function IssuesModule({ boxes }) {
  return (
    <CardWrapper>
      <h4 className={styles.title}>Go deeper with these related topics:</h4>
      <div className={styles.boxes}>
        {boxes.map(box => {
          return (
            <Link
              key={box.tagSlug}
              className={styles.box}
              style={{ backgroundColor: box.backgroundColor }}
              to={`/tag/${box.tagSlug}`}
            >
              {box.name}
            </Link>
          );
        })}
      </div>
    </CardWrapper>
  );
}

IssuesModule.propTypes = {
  boxes: PropTypes.arrayOf(
    PropTypes.shape({
      tagSlug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      backgroundColor: PropTypes.string.isRequired,
    })
  ).isRequired,
};
